// Full-page screens the page guard shows a team member instead of a page.
import React from 'react';
import { Lock, ShieldOff } from 'lucide-react';
import SetPasswordForm from './SetPasswordForm';

const Shell = ({ children }) => (
  <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-slate-950 px-4">
    <div className="w-full max-w-md rounded-2xl bg-white dark:bg-slate-900 border border-gray-200 dark:border-slate-700 shadow-sm p-8">
      {children}
    </div>
  </div>
);

/** Signed in with the emailed password; must choose their own first. */
export const ChangePasswordRequired = () => (
  <Shell>
    <div className="text-center mb-6">
      <Lock className="w-9 h-9 mx-auto text-blue-600" />
      <h1 className="mt-3 text-xl font-semibold text-gray-900 dark:text-slate-100">Choose your password</h1>
      <p className="mt-1 text-sm text-gray-500 dark:text-slate-400">
        Your team admin asked you to replace the temporary password before you continue.
      </p>
    </div>
    <SetPasswordForm onDone={() => window.location.reload()} />
  </Shell>
);

const MESSAGES = {
  owner_only: ['Only the account owner can open this', 'Plans and billing are managed by the person who owns this MARS account.'],
  feature: ['This feature is not enabled for you', 'Your account admin has not given you access to this feature. Ask them to turn it on for you.'],
  team_admin: ['Only the account admin can manage the team', 'Ask the account owner if you need different access.'],
};

export const AccessBlocked = ({ reason, featureLabel }) => {
  const [title, body] = MESSAGES[reason] || MESSAGES.feature;
  return (
    <Shell>
      <div className="text-center">
        <ShieldOff className="w-10 h-10 mx-auto text-gray-400" />
        <h1 className="mt-3 text-lg font-semibold text-gray-900 dark:text-slate-100">{featureLabel && reason === 'feature' ? `${featureLabel} is not enabled for you` : title}</h1>
        <p className="mt-2 text-sm text-gray-600 dark:text-slate-300">{body}</p>
        <a href="/dashboard" className="mt-6 inline-block rounded-lg bg-blue-600 hover:bg-blue-700 text-white px-5 py-2.5 text-sm font-semibold">Back to dashboard</a>
      </div>
    </Shell>
  );
};
